import { useState } from 'react'
import NodeSetupGuide from '../../components/NodeSetupGuide'
import RdbConnections from './RdbConnections'
import DistributedDatabase from './DistributedDatabase'
import StackGresDatabase from './StackGresDatabase'
import './style.css'

export default function DatabaseDashboard() {
  const tabs = ['rdb', 'postgres', 'distributed']
  const [tab, setTab] = useState(() => { const value = new URLSearchParams(window.location.search).get('tab'); return tabs.includes(value) ? value : 'rdb' })
  function select(value) {
    setTab(value)
    const url = new URL(window.location.href)
    url.searchParams.set('tab', value)
    window.history.replaceState(null, '', url)
  }
  function navigate(event) {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return
    event.preventDefault()
    const next = event.key === 'Home' ? tabs[0] : event.key === 'End' ? tabs[tabs.length - 1] : tabs[(tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length]
    select(next)
    document.getElementById(`${next}-tab`)?.focus()
  }
  return <div className="database-page">
    <header className="database-heading"><h1>데이터베이스</h1><p>연결 상태와 분산 노드를 관리합니다.</p></header>
    <NodeSetupGuide section="database"/>
    <div className="database-tabs" role="tablist" aria-label="데이터베이스 유형" onKeyDown={navigate}>
      <button id="rdb-tab" role="tab" tabIndex={tab === 'rdb' ? 0 : -1} aria-controls="database-panel" aria-selected={tab === 'rdb'} onClick={() => select('rdb')}>RDB</button>
      <button id="postgres-tab" role="tab" tabIndex={tab === 'postgres' ? 0 : -1} aria-controls="database-panel" aria-selected={tab === 'postgres'} onClick={() => select('postgres')}>PostgreSQL 운영</button>
      <button id="distributed-tab" role="tab" tabIndex={tab === 'distributed' ? 0 : -1} aria-controls="database-panel" aria-selected={tab === 'distributed'} onClick={() => select('distributed')}>분산 DB</button>
    </div>
    <section id="database-panel" role="tabpanel" aria-labelledby={`${tab}-tab`}>
      {tab === 'rdb' ? <RdbConnections /> : tab === 'postgres' ? <StackGresDatabase /> : <DistributedDatabase />}
    </section>
  </div>
}
